import { render, staticRenderFns } from "./OptionAction.vue?vue&type=template&id=289d6663"
import script from "./OptionAction.vue?vue&type=script&lang=js"
export * from "./OptionAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports